import moment from 'moment';
import icalendar from 'icalendar';

const getReceivedParticipant = (
  participants,
  currency,
  relatedParticipants
) => {
  return participants
    .map(participant => {
      const participantName = participant.participant[0]
        ? participant.participant[0].participant
        : null;

      const existedParticipant = relatedParticipants.find(
        activityParticipant => {
          if (participantName === activityParticipant.participant) {
            return activityParticipant;
          }
          return false;
        }
      );

      if (!existedParticipant) return false;

      return {
        ...existedParticipant,
        participants: `${participant.guestsNumber}`
      };
    })
    .filter(item => item);
};

const getReceivedAddOns = addOns => {
  return addOns.map(item => {
    const originalAddOn = item.addOn[0];
    let prices = {
      NOK: '0',
      EUR: '0',
      USD: '0'
    };
    if (originalAddOn.prices) {
      originalAddOn.prices.map(item => {
        prices[item.currency.currency] = item.value;
      });
    }
    let norwegianFields = {};
    if (originalAddOn.titleNo) {
      norwegianFields = {
        Norwegian: {
          title: originalAddOn.titleNo,
          description: originalAddOn.descriptionNo
        }
      };
    }
    return {
      originalId: parseInt(item.id),
      id: parseInt(originalAddOn.id),
      title: originalAddOn.title,
      description: originalAddOn.description,
      ...norwegianFields,
      ...prices,
      value: item.addOnCount
    };
  });
};

const getReceivedMandatoryFees = mandatoryFees => {
  return mandatoryFees?.map(item => {
    const originalMandatoryFee = item.mandatoryFee[0];
    let prices = {
      NOK: '0',
      EUR: '0',
      USD: '0'
    };
    if (originalMandatoryFee.prices) {
      originalMandatoryFee.prices.map(item => {
        prices[item.currency.currency] = item.value;
      });
    }
    let norwegianFields = {};
    if (originalMandatoryFee.titleNo) {
      norwegianFields = {
        Norwegian: {
          title: originalMandatoryFee.titleNo,
          description: originalMandatoryFee.descriptionNo
        }
      };
    }
    return {
      originalId: parseInt(item.id),
      id: parseInt(originalMandatoryFee.id),
      title: originalMandatoryFee.title,
      description: originalMandatoryFee.description,
      ...norwegianFields,
      ...prices,
      value: item.mandatoryFeeCount
    };
  });
};


const getReceivedSchedule = schedule => {
  if (!schedule) return {};

  const data = icalendar.parse_calendar(schedule).components.VEVENT[0]
    .properties;

  const startTime = {
    startTime: moment(data.START_TIME[0].value, 'HH:mm:ss').format('HH:mm'),
    duration: data.DURATION_[0].value,
    timeType: data.TIME_TYPE[0].value
  };

  return {
    startTime: {
      id: `${startTime.startTime}-${startTime.duration}-${startTime.timeType}`,
      ...startTime
    }
  };
};

export { getReceivedParticipant, getReceivedAddOns , getReceivedSchedule, getReceivedMandatoryFees };
